import Invbox from './Invbox';
import "./invest.css";
import Helmet from 'react-helmet';
import GrpInv from './GrpInv';
import Pop from './Pop';
import FooterForInv from './FooterForInv';
import BottomBox from './BottomBox';
import { Box } from '@mui/material';

function Invest(props) {
  const { history } = props;
  return (
    
    <div className="inv">
      
      
      <Pop btcolor='black'/>
      <Box 
           sx = {theme => ({ [theme.breakpoints.up('sm')]:{backgroundColor:'#202020',width:'100%',height:'50vh',maxHeight:'50%'},
           [theme.breakpoints.between('0','600')]:{backgroundColor:'#202020',width:'100%',height:'35vh',maxHeight:'50%'}
           })}
      />
    
    <p onClick={()=> history.push('/')} className='inv__head'>
      Untouched
    </p>
   
    <div className='inv__heading'>
      <p>Invest Now</p> 
      </div>
    
      
      
      <div className="content__plus__box">
      
      <div className="content">
        <div id="inv__para">
        <h1><pre>{`Investment that will make you
feel progressive`}</pre>
        </h1>
        
        <div> With the help of innovation, Project Untouched is making the community more hygienic and clean. 
        If you invest, your wealth will grow with less risk and a greater return and this innovation also make your investment more reliable</div>
        </div>
        <img id='man__img' src="images/invest/inv__img.png" alt="new__image" />
      </div>
      
      <div className="Box">
        <Invbox />
      </div>

      </div> 
        <GrpInv/>
        <BottomBox/>
       
    </div>
        
  );  
}

export default Invest;
